import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type IMenuItemProps, type IRenderContextMenuItemArgs } from '@/plugins/context-menu';
import { type Layer } from '../..';

export const layerAlignCanvasItem = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    const layer = pickLayer || activeLayer;
    const disabled = !layer;
    if (disabled) return null;
    if (framework.service.edgelessCanvas.isEdgelessMode) return null;

    const clickHandler = (type: string) => {
        const layerApi = framework.service.registration.getInstance<Layer>('Layer');
        if (!layerApi) {
            throw new Error('Layer is not found');
        }
        layerApi.canvasAlign[type]?.(activeLayer?.id);
    };

    const item: IMenuItemProps = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.alignCanvas),
        type: 'alignCanvas',
        childMenus: [
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignLeft),
                type: 'left',
                icon: 'AlignLeftBold',
                onClick: () => clickHandler('left'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignHorizontal),
                type: 'horizontalCenter',
                icon: 'AlignHorizontalCenterBold',
                onClick: () => clickHandler('horizontalCenter'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignRight),
                type: 'right',
                icon: 'AlignRightBold',
                onClick: () => clickHandler('right'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignTop),
                type: 'top',
                icon: 'AlignTopBold',
                onClick: () => clickHandler('top'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignVertical),
                type: 'verticalCenter',
                icon: 'AlignVerticalCenterBold',
                onClick: () => clickHandler('verticalCenter'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignBottom),
                type: 'bottom',
                icon: 'AlignBottomBold',
                onClick: () => clickHandler('bottom'),
            },
        ],
    };

    return item;
};
